import React from "react";
import AvailableClassCard from "./AvailableClassCard";
import PrivateDateCard from "./PrivateDateCard";
import { CousrsDetailsType } from "@/app/types";

function DiscktopDatesCards({course}:DatesCardsPropsType) {
  return (
    <div className="flex lg:gap-32 gap-7">
       <div className={`flex-1 flex  `}>
        <AvailableClassCard course={course}/>
      </div>
      <div className={`flex-1 flex `}>
       <PrivateDateCard course={course}/>
      </div>

     
    </div>
  );
}

export default DiscktopDatesCards;
type DatesCardsPropsType={
  course:CousrsDetailsType
}